
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#4ECD97"}}),_c('g',{attrs:{"clip-path":"url(#tw-projects-enhancement-icon-clip0_3814_5859)"}},[_c('path',{attrs:{"d":"M15 10v11h3v9l7-12h-4l3-8h-9z","fill":"#0B0E1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"tw-projects-enhancement-icon-clip0_3814_5859"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8 8)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    